module.exports = __webpack_public_path__ + "img/boy2.1e24b9d2.png";